import { render, staticRenderFns } from "./redirectDetail.vue?vue&type=template&id=6a1bac60"
import script from "./redirectDetail.vue?vue&type=script&lang=js"
export * from "./redirectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports